import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import VideoPlayer from "@core/components/VideoPlayer";

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('video-player', VideoPlayer)
